<template lang="html">
  <section class="section">
    <div class="container has-text-centered">
      <h1 class="title">
        Oops !
      </h1>
      <h2 class="subtitle">
        The page you're looking for doesn't exist !
      </h2>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
